// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"f01d5dc75cc4d833b99b","873":"883b83d89ca863f29c82"}[chunkId] + ".js";
};